<template>
  <div class="photo">
    <img :src="imagePath" alt="Image" />
    <div class="photo__overlay" @click="onClickMaximize">
      <button type="button" class="photo__action photo__action_open">Открыть</button>
      <button type="button" class="photo__action photo__action_delete" @click="deleteImage">
        Удалить
      </button>
    </div>
    <div
      v-if="isMaximized"
      class="photo__maximized"
      :class="{ photo__maximized_active: isMaximized }"
      @click.stop="onClickMaximize"
      @keydown.esc="onClickMaximize"
    >
      <img :src="imagePreviewPath" />
      <button type="button" class="photo__maximized__close">Закрыть</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'photo',
  props: {
    photo: { type: Object, required: true },
    path: { type: String, default: 'path' },
    previewPath: { type: String, default: 'preview_path' },
  },
  computed: {
    imagePath() {
      return this.photo[this.path];
    },
    imagePreviewPath() {
      return this.photo[this.previewPath];
    },
  },
  data() {
    return {
      isMaximized: false,
    };
  },
  methods: {
    async deleteImage(event = undefined) {
      event?.stopPropagation();

      const userAgreed = await this.$bvModal.msgBoxConfirm(
        'Вы действительно хотите удалить изображение?',
        {
          okTitle: 'Удалить',
          cancelTitle: 'Отмена',
          cancelVariant: 'outline-secondary',
        },
      );

      if (!userAgreed) {
        return;
      }

      this.$emit('delete', this.photo);
    },
    onClickMaximize() {
      const newVal = !this.isMaximized;
      this.isMaximized = newVal;
      if (newVal) {
        document.addEventListener('keydown', this.listenForEsc);
      } else {
        document.removeEventListener('keydown', this.listenForEsc);
      }
    },
    listenForEsc(event) {
      if (event.key === 'Escape') {
        this.onClickMaximize();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.photo {
  height: 150px;
  width: 150px;
  min-height: 150px;
  min-width: 150px;
  position: relative;
  border: 1px solid #eaecf0;
  border-radius: 12px;
  overflow: hidden;
  user-select: none;

  &:hover {
    .photo__overlay {
      opacity: 1;
      transition: all 0.2s linear;
    }
  }

  & img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  &__overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 7px;
    padding: 12px;
    opacity: 0;
    background: linear-gradient(180deg, transparent 30%, rgba(16, 24, 40, 0.72));
    z-index: 1;
    transition: all 0.2s linear;
  }

  &__action {
    padding: 6px 10px;
    border: 0;
    border-radius: 7px;
    background: rgba(255, 255, 255, 0.94);
    color: #475467;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;

    &_open:hover {
      color: #175cd3;
      background: #eff8ff;
    }

    &_delete:hover {
      color: #d92d20;
      background: #fef3f2;
    }
  }

  &__maximized {
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    padding: 48px;
    background: rgba(16, 24, 40, 0.94);
    z-index: 2000;

    & img {
      object-fit: contain;
    }

    &__close {
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
      padding: 8px 12px;
      border: 1px solid rgba(255, 255, 255, 0.35);
      border-radius: 8px;
      color: #fff;
      background: rgba(16, 24, 40, 0.5);
      font-weight: 600;

      &:hover {
        background: rgba(255, 255, 255, 0.14);
      }
    }
  }
}
</style>
